import React, { useEffect } from 'react';
import { useImageModalContext } from './ImageSelectModal';
import { ImageModalHeader } from './SharedComponents';
import { SkipperPaperEditor } from '@components/editor/paper/SkipperPaperEditor';

export function CreateSkipperPaper({ toggle }: { toggle: any }) {
    const { fileCreate, authorizer } = useImageModalContext();

    return (
        <div className="relative flex flex-col flex-1 overflow-hidden">
            <div>
                <ImageModalHeader onClick={() => toggle(false)} text="Skipper Paper" />
            </div>
            <div className="overflow-hidden grow">
                <SkipperPaperEditor
                    createFile={fileCreate}
                    authorizer={authorizer}
                    embedded={true}
                />
            </div>
        </div>
    );
}
